<div class="grid justify-content-center">

    <div class="col-3">

        <p-card header="Password Recovery" subheader="{{subHeader}}" class="ui-card-light">

            <!--  The user is prompted for his/her username to get an email with a temp password -->

            @if (phase == "pswd-reset-request") {

                <form [formGroup]="requestPasswordResetForm">

                    <div class="field grid">
                        <div class="col-1"></div>
                        <label for="userName" class="col-fixed label" style="width: 9em">Username:</label>
                        <div class="col-7">
                            <input pInputText type="text" id="userName" formControlName="userName" style="width: 100%;"/>
                        </div>
                    </div>

                    <div class="field grid">
                        <div class="col-1"></div>
                        <label for="emailAddress" class="col-fixed label" style="width: 9em">Email Address:</label>
                        <div class="col-7   ">
                            <input pInputText type="email" id="emailAddress" formControlName="emailAddress" style="width: 100%;"/>
                        </div>
                    </div>

                    <div class="d-flex justify-content-center">
                        <div class="mx-2">
                            <p-button type="button" label="Submit"  
                                (click)="onRequestPasswordReset()" 
                                [disabled]="!requestPasswordResetForm.valid"
                                styleClass="p-button-success wal-success p-button-raised p-button-rounded">
                            </p-button>
                            <!-- || !isCaptchaVerified -->
                        </div>

                        <p-button type="button" label="Cancel" (click)="onCancel()"
                            styleClass="p-button-primary wal-primary p-button-raised p-button-rounded">
                        </p-button>
                    </div>

                </form>

                <br/>

                <!-- reCaptcha v2 implementation -->
                <!-- <div class="captcha-form-row">
                    <div class="captcha-wrapper">
                        <ngx-recaptcha2 
                            [siteKey]="siteKey"
                            (success)="onCaptchaSuccess($event)"
                            (error)="onCaptchaError($event)"
                            (expire)="onCaptchaExpire()"
                        ></ngx-recaptcha2>
                    </div>
                </div> -->

                <br/>


                <div class="d-flex justify-content-center">
                    <div class="mx-2">
                        <a href="javascript:void(0)" (click)="onForgotUserName()">Forgot username</a>
                    </div>
                </div>


            }

            <!--  The user is prompted for his/her email address to receive an email with the username -->

            @if (phase == "user-name-recov") {

                <form [formGroup]="userNameRecoveryForm" (ngSubmit)="onRecoverUserName(userNameRecoveryForm.value)">

                    <div class="field grid">
                        <div class="col-1"></div>
                        <label for="emailAddress" class="col-fixed label" style="width: 9em">Email Address:</label>
                        <div class="col-7">
                            <input pInputText type="email" id="emailAddress" formControlName="emailAddress" style="width: 100%;"/>
                        </div>
                    </div>

                    <div class="d-flex justify-content-center">
                        <div class="mx-2">

                            <p-button type="submit" label="Submit" 
                                styleClass="p-button-success wal-success p-button-raised p-button-rounded margin-left" 
                                [disabled]="!userNameRecoveryForm.valid">
                            </p-button>

                        </div>

                        <p-button type="button" label="Cancel" (click)="onCancel()"
                            styleClass="p-button-primary wal-primary p-button-raised p-button-rounded">
                        </p-button>
                    </div>

                </form>

            }
<!-- 
            @if (phase == "password-reset") {

                <form [formGroup]="passwordResetForm">

                    <div class="field grid">
                        <div class="col-1"></div>
                            <label for="tempPassword" class="col-fixed label" style="width: 12em">Temporary Password:</label>
                        <div class="col-6">
                            <input pPassword type="tempPassword" id="tempPassword" formControlName="tempPassword"/>
                            <div *ngIf="!passwordResetForm.controls['tempPassword'].valid && passwordResetForm.controls['tempPassword'].dirty" class="alert alert-danger">
                                Incorrect temporary password
                            </div>                                    
                        </div>
                    </div>
                    
                    <div class="field grid">
                        <div class="col-1"></div>
                            <label for="newPassword" class="col-fixed label" style="width: 12em">New Password:</label>
                        <div class="col-6">
                            <input pPassword type="password" id="newPassword" formControlName="newPassword"/>
                            <div *ngIf="!passwordResetForm.controls['newPassword'].valid && passwordResetForm.controls['newPassword'].dirty" class="alert alert-danger">
                                Incorrect new password
                            </div>                                    
                        </div>
                    </div>
                    
                    <div class="field grid">
                        <div class="col-1"></div>
                            <label for="confirmPassword" class="col-fixed label" style="width: 12em">Confirm Password:</label>
                        <div class="col-6">
                            <input pPassword type="password" id="confirmPassword"  formControlName="confirmPassword"/>
                            <div *ngIf="!passwordResetForm.controls['confirmPassword'].valid && passwordResetForm.controls['confirmPassword'].dirty" class="alert alert-danger">
                                Incorrect confirm password
                            </div>                                    
                        </div>
                    </div>

                    <div class="d-flex justify-content-center">
                        <div class="mx-2">
                            <p-button type="button" label="Submit"  
                                (click)="onSubmitPasssword()" 
                                [disabled]="!passwordResetForm.valid"
                                styleClass="p-button-success wal-success p-button-raised p-button-rounded">
                            </p-button>
                        </div>

                        <p-button type="button" label="Cancel" (click)="onCancel()"
                            styleClass="p-button-primary wal-primary p-button-raised p-button-rounded">
                        </p-button>
                    </div>

                </form>
            
            }
 -->
        </p-card>

    </div>

</div>

<p-confirmDialog class="lf-confirm-dialog" appendTo="body" key="password-reset"></p-confirmDialog>


